import React from 'react';
import { useDispatch } from 'react-redux';
import { FiFileText } from 'react-icons/fi';
import { openCathedraFile } from '../../../actions/cathedras';
import { formatDate, formatSize } from '../format';
import styles from '../card.module.css';

/* Вкладка «Файлы» (п. 11 ТЗ). Список плашек: имя файла, справа — тип, размер и
   дата загрузки. Клик открывает файл на просмотр или скачивание. Кнопок
   «Добавить», «Заменить», «Удалить» нет. */

const meta = (file) => [
  file.type,
  formatSize(file.size),
  formatDate(file.uploaded_at),
].filter(Boolean).join(' · ');

const Files = ({ id, data }) => {
  const dispatch = useDispatch();

  if (!data.items.length) {
    return (
      <div className={styles.empty}>
        <div className={styles.emptyTitle}>Файлов нет</div>
        К кафедре не прикреплено ни одного документа
      </div>
    );
  }

  return (
    <div className={styles.pane}>
      <div className={styles.filelist}>
        {data.items.map(file => (
          <button
            key={file.id}
            type="button"
            className={styles.filerow}
            onClick={() => dispatch(openCathedraFile(id, file.id, file.name))}
          >
            <FiFileText size={18} className={styles.fileIcon} />
            <span className={styles.fname}>{file.name}</span>
            <span className={styles.fmeta}>{meta(file)}</span>
          </button>
        ))}
      </div>
      <div className={styles.counter}>Всего записей: <b>{data.count}</b></div>
    </div>
  );
};

export default Files;
